export const FONT_COLORS = {
    "#0F1F43": "#EEE7DC",
    "#274BA1": "#EEE7DC",
    "#EEE7DC": "#0F1F43",
    "#F6F3ED": "#0F1F43"
}